import {
  Box,
  Button,
  Chip,
  CircularProgress,
  Divider,
  Paper,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import MenuItemMui from "@mui/material/MenuItem";
import { MenuItem } from "react-pro-sidebar";
import Header from "../../components/Header";
import { tokens } from "../../theme";
import { DatePicker, LocalizationProvider } from "@mui/x-date-pickers";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import {
  Add,
  Addchart,
  Circle,
  Edit,
  ListAlt,
  RestartAlt,
  SaveAlt,
  SaveAs,
  WrapText,
  Wysiwyg,
} from "@mui/icons-material";
import React, { useEffect, useMemo, useReducer, useState } from "react";
import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import NotificationToaste from "../global/NotificationToaste";
import axios from "axios";
import { DATA_SAVE_URL } from "../utils/UrlHandle";
import NewJobAddTest from "./NewJobAddTest";
import {
  AddTestDataToTable,
  initialValues,
  reducer,
} from "./NewJobRequestUtils";
import dayjs, { utc } from "dayjs";
import timezone from "dayjs/plugin/timezone";
import JobInvoiceDialog from "./JobInvoiceDialog";
import LoadingBackDrop from "../global/LoadingBackDrop";
import {
  authAPI,
  getPayload,
  setPostPayload,
  setPutPayload,
} from "../../services/api";
import PDFViewerDialog from "../jasperReports/PDFViewerDialog";
dayjs.extend(utc);
dayjs.extend(timezone);
dayjs.tz.setDefault("Asia/Colombo");
const NewJobRequest = React.memo(() => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  const isNonMobile = useMediaQuery("(min-width:600px)");
  const [institutes, setInstitutes] = useState([]);
  const [institute, setInstitute] = useState({});
  //   for success or error message
  const [open, setOpen] = useState(false);
  const [message, setMessage] = useState();
  const [messageType, setMessageType] = useState();
  const [update, setUpdate] = useState(false);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState([]);
  const [officers, setOfficers] = useState([]);
  const [labTestsArray, setLabTestsArray] = useState({
    grandTotal: "",
    testsArray: [],
  });
  const [year, setYear] = useState([
    { id: 1, label: "2025", value: "2025" },
    { id: 2, label: "2026", value: "2026" },
  ]);
  const [currentYear, setCurrentYear] = useState(2026);
  const [selectedRequestId, setSelectedRequestId] = useState({});
  const handleCloseToaste = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
  };
  const [pagination, setPagination] = useState({
    pageIndex: 0,
    pageSize: 25,
  });

  const loggedUser = JSON.parse(localStorage.getItem("user"));

  // console.log("loggedUser,", loggedUser);

  const [totalRecords, setTotalRecords] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [mainData, setMainData] = useState({
    id: "",
    year: "",
    autoIdByYear: "",
    registerDate: {
      registerDate: dayjs(new Date()),
      error: false,
      helperText: "",
    },
    institute: {
      id: "",
      institute: "",
      error: false,
      helperText: "",
    },
    project: {
      project: "",
      error: false,
      helperText: "",
    },
    contactPerson: "",
    contactNo: "",
    mobileNo: "",
    whatsAppNo: "",
    email: "",
    labRequestsInvoice: {
      id: "",
      invoiceDate: "",
      invoiceNumber: "",
      systemUser: "",
      payment: "",
      paymentMethod: "",
    },
    preparedBy: {},
    assignUser: {
      id: "",
      error: false,
      helperText: "",
    },
  });

  const handleGenerateId = () => {
    if (
      mainData.registerDate.registerDate === "" ||
      mainData.institute.id === "" ||
      mainData.project.project === "" ||
      mainData.assignUser.id === undefined ||
      mainData.assignUser.id === "" ||
      mainData.mobileNo === "" ||
      mainData.whatsAppNo === ""
    ) {
      if (mainData.institute.id === "") {
        setMessage("Please select Institute / Contractor!");
        setMessageType("warning");
        setOpen(true);

        setMainData((pre) => ({
          ...pre,
          institute: {
            ...pre.institute,
            error: pre.institute.id === "" ? true : false,
            helperText: pre.institute.id === "" ? "Select institute!" : "",
          },
        }));
        return;
      }

      if (mainData.project.project === "") {
        setMessage("Please enter project name!");
        setMessageType("warning");
        setOpen(true);

        setMainData((pre) => ({
          ...pre,
          project: {
            ...pre.project,
            error: pre.project.project === "" ? true : false,
            helperText: pre.project.project === "" ? "Enter project name!" : "",
          },
        }));
        return;
      }

      if (
        mainData.assignUser.id === undefined ||
        mainData.assignUser.id === ""
      ) {
        setMessage("Please select technical officer (T.O / A.T.O)!");
        setMessageType("warning");
        setOpen(true);

        setMainData((pre) => ({
          ...pre,
          assignUser: {
            ...pre.assignUser,
            error:
              pre.assignUser.id === "" || pre.assignUser.id === undefined
                ? true
                : false,
            helperText: pre.assignUser.id === "" ? "Select assign user!" : "",
          },
        }));
        return;
      }

      if (mainData.mobileNo === "" || mainData.whatsAppNo === "") {
        setMessage("Please enter Mobile No & WhatsApp No!");
        setMessageType("warning");
        setOpen(true);
        return;
      }
    } else {
      setMainData((pre) => ({
        ...pre,
        registerDate: {
          ...pre.registerDate,
          error: false,
          helperText: "",
        },
        institute: {
          ...pre.institute,
          error: false,
          helperText: "",
        },
        project: {
          ...pre.project,
          error: false,
          helperText: "",
        },
        project: {
          ...pre.assignUser,
          error: false,
          helperText: "",
        },
      }));
      saveGenerateIdData();
    }
  };

  const handleUpdateTestName = () => {
    if (
      mainData.registerDate.registerDate === "" ||
      mainData.institute.id === "" ||
      mainData.project.project === ""
    ) {
      setMainData((pre) => ({
        ...pre,
        registerDate: {
          ...pre.registerDate,
          error: pre.registerDate.registerDate === "" ? true : false,
          helperText: pre.registerDate.registerDate === "" ? "Enter date!" : "",
        },
        institute: {
          ...pre.institute,
          error: pre.institute.id === "" ? true : false,
          helperText: pre.institute.id === "" ? "Select institute!" : "",
        },
        project: {
          ...pre.project,
          error: pre.project.project === "" ? true : false,
          helperText: pre.project.project === "" ? "Enter project name!" : "",
        },
      }));
    } else {
      setMainData((pre) => ({
        ...pre,
        registerDate: {
          ...pre.registerDate,
          error: false,
          helperText: "",
        },
        institute: {
          ...pre.institute,
          error: false,
          helperText: "",
        },
        project: {
          ...pre.project,
          error: false,
          helperText: "",
        },
      }));

      if (labTestsArray.testsArray.length === 0) {
        setMessage("No tests found for the selected request!");
        setMessageType("warning");
        setOpen(true);
        return;
      }

      updateTestName();
    }
  };

  const updateTestName = async () => {
    const labObject = {
      id: mainData.id,
      project: mainData.project.project,
      institute: institute,
      regDate: mainData.registerDate.registerDate,
      contactPerson: mainData.contactPerson,
      contactNo: mainData.contactNo,
      mobileNo: mainData.mobileNo,
      whatsAppNo: mainData.whatsAppNo,
      email: mainData.email,
      grandTotal: labTestsArray.grandTotal,
      labRequestTests: labTestsArray.testsArray,
      year: mainData.year,
    };

    const sendObject = {
      id: labObject.id,
      project: labObject.project,
      mobileNo: labObject.mobileNo,
      whatsAppNo: labObject.whatsAppNo,
      contactNo: labObject.contactNo,
    };

    await setPutPayload
      .setPayloadData("/labReq/updateProjectName", sendObject)
      .then(function (response) {
        // console.log(response.data);

        if (response.data === "") {
          setLoading(false);
          setMessage(
            "Cannot update selected Job. Please delete the payments befor update the request..!",
          );
          setMessageType("error");
          setOpen(true);
        } else {
          setMainData((pre) => ({
            ...pre,
            id: response.data.id,
            year: response.data.year,
          }));
          setLabTestsArray((pre) => ({
            ...pre,
            grandTotal: 0,
            testsArray: [],
          }));
          setMessage("Data saved successfully..!");
          setMessageType("success");
          setOpen(true);
          setUpdate(false);
          loadBasicData();
          handleResetForm();
        }
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  //reducer method
  const [state, setState] = useReducer(reducer, initialValues);
  const cleanLabRequestTests = (testsArray) => {
    return testsArray.map((test) => ({
      id: test.id || 0, // Use 0 for new entries
      requestId: test.requestId || 0,
      labRequest: update ? { id: mainData?.id } : null,
      reportCollectMethod: test.reportCollectMethod || "Lab",
      sampleCollectMethod: test.sampleCollectMethod || "Visit site",
      amount: test.amount || 0,
      quantity: test.quantity || 0,
      total: test.total || 0,
      startingSerialNo: test.startingSerialNo || 0,
      balanceQuantity: test.balanceQuantity || test.quantity || 0,
      assignDate: test.assignDate || null,
      finalized: test.finalized || false,
      checked: test.checked || false,
      checkedByEngineer: test.checkedByEngineer || false,
      returned: test.returned || false,
      emailSent: test.emailSent || false,
      rejectReason: test.rejectReason || null,
      // Only include necessary nested IDs, not full objects
      labTest: { id: test.labTest?.id || test.labTestId }, // Handle both structures
      assignUser: { id: mainData.assignUser?.id, role: "USER" }, // Only ID, not full user object
      castingDate: test.castingDate || null,
      testDate: test.testDate === "Invalid Date" ? null : test.testDate,
    }));
  };

  const saveGenerateIdData = async () => {
    if (!update) {
      const labObject = {
        project: mainData.project.project,
        institute: { id: institute.id },
        regDate: mainData.registerDate.registerDate,
        contactPerson: mainData.contactPerson,
        contactNo: mainData.contactNo,
        mobileNo: mainData.mobileNo,
        whatsAppNo: mainData.whatsAppNo,
        email: mainData.email,
        grandTotal: labTestsArray.grandTotal,
        labRequestTests: cleanLabRequestTests(labTestsArray.testsArray || []),
        labRequestInvoice: {
          invoiceDate: "",
          invoiceNumber: "",
          systemUser: "system",
          payment: labTestsArray.grandTotal,
          paymentMethod: "",
        },
        preparedBy: { id: loggedUser.id, role: "USER" },
        assignUser: { id: mainData.assignUser?.id, role: "USER" },
      };

      // console.log("--------", labObject);
      setLoading(true);
      await setPostPayload
        .setPayloadData("/labReq", labObject)
        .then(function (response) {
          // console.log("response data : ", response.data);
          setLabTestsArray((pre) => ({
            ...pre,
            grandTotal: 0,
            testsArray: [],
          }));
          setMessage(
            "Data saved successfully..! Job No : " +
              response.data.year +
              "/" +
              String(response.data.autoIdByYear).padStart(4, "0"),
          );
          setLoading(false);
          setMessageType("success");
          setOpen(true);
          loadBasicData(pagination.pageIndex, pagination.pageSize, currentYear);
        })
        .catch(function (error) {
          console.log(error);
        });
    } else {
      const labObject = {
        id: mainData.id,
        project: mainData.project.project,
        autoIdByYear: mainData.autoIdByYear,
        institute: { id: institute.id },
        regDate: mainData.registerDate.registerDate,
        contactPerson: mainData.contactPerson,
        contactNo: mainData.contactNo,
        mobileNo: mainData.mobileNo,
        whatsAppNo: mainData.whatsAppNo,
        email: mainData.email,
        grandTotal: labTestsArray.grandTotal,
        labRequestTests: cleanLabRequestTests(labTestsArray.testsArray || []),
        year: mainData.year,
        preparedBy: { id: loggedUser.id, role: "USER" },
        assignUser: { id: mainData.assignUser?.id, role: "USER" },
      };

      setLoading(true);
      await setPutPayload
        .setPayloadData("/labReq", labObject)
        .then(function (response) {
          // console.log(response.data);

          if (response.data === "") {
            setMessage(
              "Cannot update selected Job. Please delete the payments before update the request..!",
            );
            setMessageType("error");
            setOpen(true);
            setLoading(false);
          } else {
            setMainData((pre) => ({
              ...pre,
              id: response.data.id,
              year: response.data.year,
            }));
            setLabTestsArray((pre) => ({
              ...pre,
              grandTotal: 0,
              testsArray: [],
            }));
            setLoading(false);
            setMessage("Data saved successfully..!");
            setMessageType("success");
            setOpen(true);
            setUpdate(false);
            loadBasicData(
              pagination.pageIndex,
              pagination.pageSize,
              currentYear,
            );
            handleResetForm();
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    }
  };

  useEffect(() => {
    loadBasicData(pagination.pageIndex, pagination.pageSize, currentYear);
  }, [pagination.pageIndex, pagination.pageSize]);

  const loadBasicData = async (
    pageIndex = 0,
    pageSize = 25,
    selectedYear = 2026,
  ) => {
    setIsLoading(true);
    const token = localStorage.getItem("token");
    try {
      const response = await axios.get(
        `${DATA_SAVE_URL}/api/v1/institute/all/newJob?page=${pageIndex}&size=${pageSize}&year=${selectedYear}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
      // console.log("All requests", response.data.allRequests);
      setInstitutes(response.data.institutes);
      setData(response.data.allRequests);
      setOfficers(response.data.allUsers);
      setTotalRecords(response.data.totalElements);
    } catch (error) {
      console.log(error);
      setMessage("Error loading data");
      setMessageType("error");
      setOpen(true);
    } finally {
      setIsLoading(false);
      setLoading(false);
    }
  };

  const [openModal, setOpenModal] = useState(false);
  const [openInvoiceModal, setOpenInvoiceModal] = useState(false);
  const [openProgressModal, setOpenProgressModal] = useState(false);

  const handleClickOpenModal = () => {
    setOpenModal(true);
  };

  const handleCloseModal = () => {
    setOpenModal(false);
    // handleAddTest();
  };

  const handleInvoiceCloseModal = () => {
    setOpenInvoiceModal(false);
    // view invoice();
  };

  const handleProgressCloseModal = () => {
    setOpenProgressModal(false);
    // view invoice();
  };

  const handleClickInvoiceOpenModal = () => {
    setOpenInvoiceModal(true);
  };

  //Load institute related data

  useEffect(() => {
    if (mainData.institute.id === "") {
      return;
    }
    handleLoadFromDbInstitueData();
  }, [mainData.institute.id]);

  const handleLoadFromDbInstitueData = async () => {
    await getPayload
      .getPayloadData(`/institute/${mainData.institute.id}`)
      .then(function (response) {
        // console.log("re", response.data);
        setMainData((pre) => ({
          ...pre,
          contactPerson: response.data.instituteName,
          contactNo: response.data.mobileNo,
          email: response.data.email,
          // assignUser: {
          //   ...pre.assignUser,
          //   id: response.data.assignUser?.id,
          // },
        }));
        setInstitute(response.data);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleJasperReport = async () => {
    // console.log(selectedRequestId);
    await axios
      .get(DATA_SAVE_URL + "/api/v1/reports/labReq/" + selectedRequestId.id, {
        responseType: "blob",
      })
      .then(function (response) {
        // console.log(response.data);

        const blob = new Blob([response.data], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);

        // Open in new tab
        window.open(url, "_blank");

        // Optional: Revoke object URL after some time to free memory
        setTimeout(() => URL.revokeObjectURL(url), 1000);
      })
      .catch(function (error) {
        console.log(error);
      });
  };

  const handleLoadInstituteData = (e) => {
    setMainData((pre) => ({
      ...pre,
      institute: {
        ...pre.institute,
        id: e.target.value,
      },
    }));
  };

  //should be memoized or stable
  const columns = useMemo(
    () => [
      {
        accessorFn: (row) =>
          `${row.year}/${String(row.autoIdByYear).padStart(4, "0")}`,
        header: "Job No",
        size: 10,
      },
      {
        accessorKey: "institute.instituteName",
        header: "Institute",
        size: 80,
        muiTableBodyCellProps: {
          sx: {
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflow: "hidden",
          },
        },
      },
      {
        accessorKey: "regDate", //normal accessorKey
        header: "Date",
        size: 50,
      },
      {
        accessorKey: "project",
        header: "Project Name",
        size: 200,
        muiTableBodyCellProps: {
          sx: {
            whiteSpace: "normal",
            wordWrap: "break-word",
            overflow: "hidden",
          },
        },
      },
      {
        accessorFn: (row) =>
          `${row.grandTotal.toLocaleString(undefined, {
            minimumFractionDigits: 2,
            muiTableHeadCellProps: {
              align: "right",
            },
            muiTableBodyCellProps: {
              align: "right",
            },
            muiTableFooterCellProps: {
              align: "right",
            },
          })}`,
        header: "Amount",
        size: 80,
      },
    ],
    [],
  );
  const table = useMaterialReactTable({
    columns,
    data,
    enableRowActions: true,
    positionActionsColumn: "last",

    // Manual pagination configuration
    manualPagination: true,
    rowCount: totalRecords,
    onPaginationChange: setPagination,

    // State management
    state: {
      pagination,
      isLoading: isLoading,
    },

    // Remove initial pagination state since we're using manual pagination
    initialState: {
      density: "compact",
      // Remove pagination from initialState when using manualPagination
    },

    muiPaginationProps: {
      rowsPerPageOptions: [25, 100, 500, 1000, 2000],
    },

    muiTableBodyRowProps: ({ row }) => ({
      sx: {
        padding: "10px",
        backgroundColor: row.original.paid === true ? "" : "#FFDB15",
      },
    }),

    renderRowActionMenuItems: ({ closeMenu, row }) => [
      <MenuItem
        key={1}
        onClick={() => {
          handleLoadEditDataRequest(row.original);
          closeMenu();
        }}
      >
        <Button variant="text" fullWidth startIcon={<Edit />}>
          <Typography variant="subtitle1">Edit Selected Job</Typography>
        </Button>
      </MenuItem>,
      <MenuItem
        key={2}
        onClick={() => {
          setSelectedRequestId(row.original);
          handleClickInvoiceOpenModal();
          closeMenu();
        }}
      >
        <Button variant="text" fullWidth startIcon={<ListAlt />}>
          <Typography variant="subtitle1">View Quotation</Typography>
        </Button>
      </MenuItem>,

      <MenuItem
        key={3}
        onClick={() => {
          setSelectedRequestId(row.original);
          setOpenProgressModal(true);
          closeMenu();
        }}
      >
        <Button variant="text" fullWidth startIcon={<Addchart />}>
          <Typography variant="subtitle1">View Progress</Typography>
        </Button>
      </MenuItem>,
    ],
  });

  const handleLoadEditDataRequest = async (data) => {
    setLoading(true);
    setUpdate(true);

    await getPayload
      .getPayloadData(`/labReq/${data.id}`)
      .then(function (response) {
        console.log("response data", response.data);

        setMainData((pre) => ({
          ...pre,
          id: response.data.id,
          year: response.data.year,
          autoIdByYear: response.data.autoIdByYear,
          registerDate: {
            ...pre.registerDate,
            registerDate: dayjs(new Date(response.data.regDate)),
          },
          institute: {
            ...pre.institute,
            id: response.data.institute.id,
            institute: response.data.institute.institute,
          },
          project: { ...pre.project, project: response.data.project },
          contactNo: response.data.contactNo,
          mobileNo: response.data.mobileNo,
          whatsAppNo: response.data.whatsAppNo,
          contactPerson: response.data.contactPerson,
          email: response.data.email,
          labRequestsInvoice: response.data.labRequestsInvoice,
          assignUser: {
            ...pre.assignUser,
            id: response.data.assignUser ? response.data.assignUser.id : "",
            role: "USER",
          },
        }));
        setLabTestsArray((pre) => ({
          ...pre,
          testsArray: response.data.labRequestTests,
          grandTotal: response.data.grandTotal,
        }));
        setLoading(false);
      })
      .catch(function (error) {
        console.log(error);
        setMessage(error);
        setMessageType("error");
        setOpen(true);
        setLoading(false);
      });
  };

  const handleResetForm = () => {
    setUpdate(false);
    setMainData({
      id: "",
      year: "",
      registerDate: {
        registerDate: dayjs(new Date()),
        error: false,
        helperText: "",
      },
      institute: {
        id: "",
        institute: "",
        error: false,
        helperText: "",
      },
      project: {
        project: "",
        error: false,
        helperText: "",
      },
      contactPerson: "",
      contactNo: "",
      mobileNo: "",
      whatsAppNo: "",
      email: "",
    });
    setLabTestsArray((pre) => ({
      ...pre,
      grandTotal: 0,
      testsArray: [],
    }));
  };

  const handleRemoveSeleced = (value, amount) => {
    // console.log(labTestsArray);

    const newArrya = labTestsArray.testsArray.filter(
      (ele) => ele.labTest.id !== value,
    );

    setLabTestsArray((pre) => ({
      ...pre,
      grandTotal: newArrya.length === 0 ? 0 : pre.grandTotal - Number(amount),
      testsArray: newArrya,
    }));
  };
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      {loading ? <LoadingBackDrop openBackDrop={loading} /> : ""}
      <Paper
        sx={{ padding: "15px", borderRadius: "8px", width: "95%" }}
        elevation={3}
      >
        <Box display="flex" justifyContent="space-between">
          <Header title="New Job Request" subtitle="Create new requests" />
          <Box
            sx={{
              textAlign: "center",
              alignContent: "center",
            }}
          >
            <Typography
              color={colors.redAccent[500]}
              alignContent="center"
              variant="h3"
            >
              {mainData.id !== ""
                ? "Job No " +
                  mainData.year +
                  "/" +
                  String(mainData.autoIdByYear).padStart(4, "0")
                : "Job Number :  Auto"}
            </Typography>
          </Box>
        </Box>

        <Box
          display="grid"
          gap="3px"
          rowGap="10px"
          gridTemplateColumns="repeat(8, minmax(0, 1fr))"
          sx={{
            "& > div": {
              gridColumn: isNonMobile ? undefined : "span 8",
            },
          }}
        >
          <Box
            sx={{
              gridColumn: "span 2",
              alignContent: "center",
            }}
          >
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DemoContainer
                components={["DatePicker"]}
                sx={{ width: "100%", overflowX: "hidden" }}
              >
                <DatePicker
                  label="Request Date"
                  format="YYYY-MM-DD"
                  timezone="Asia/Colombo"
                  sx={{
                    width: "100%", // makes DatePicker take full width of container
                    "& .MuiInputBase-root": {
                      width: "100%", // makes input take full width
                    },
                    "& .MuiInputBase-input": {
                      width: "100%", // makes input content take full width
                    },
                  }}
                  value={dayjs(mainData.registerDate.registerDate).tz(
                    "Asia/Colombo",
                    true,
                  )}
                  slotProps={{
                    textField: {
                      variant: "outlined",
                      size: "small",
                      error: mainData.registerDate.error,
                      helperText: mainData.registerDate.helperText,
                    },
                  }}
                  onChange={(newVal) => {
                    setMainData((pre) => ({
                      ...pre,
                      registerDate: {
                        ...pre.registerDate,
                        registerDate: newVal?.tz("Asia/Colombo", true),
                      },
                    }));
                  }}
                />
              </DemoContainer>
            </LocalizationProvider>
          </Box>
          <Box
            sx={{
              gridColumn: "span 2",
              alignContent: "center",
            }}
          >
            <TextField
              select
              label="Institute / Contractor"
              fullWidth
              size="small"
              defaultValue=""
              sx={{ marginTop: "8px" }}
              error={mainData.institute.error}
              helperText={mainData.institute.helperText}
              onChange={handleLoadInstituteData}
              value={mainData.institute.id}
            >
              {institutes?.map((option) => (
                <MenuItemMui key={option.id} value={option.id}>
                  {option.instituteName}
                </MenuItemMui>
              ))}
            </TextField>
          </Box>
          <TextField
            variant="outlined"
            type="text"
            label="Project"
            size="small"
            error={mainData.project.error}
            helperText={mainData.project.helperText}
            sx={{
              gridColumn: "span 4",
              marginTop: "8px",
            }}
            value={mainData.project.project}
            onChange={(e) =>
              setMainData((pre) => ({
                ...pre,
                project: {
                  ...pre.project,
                  project: e.target.value,
                },
              }))
            }
          />
          <TextField
            variant="outlined"
            type="text"
            label="Contact Person"
            size="small"
            value={mainData.contactPerson}
            onChange={(e) =>
              setMainData((pre) => ({ ...pre, contactPerson: e.target.value }))
            }
            sx={{
              gridColumn: "span 2",
              marginTop: "8px",
            }}
          />
          <TextField
            variant="outlined"
            type="text"
            label="Contact No"
            size="small"
            value={mainData.contactNo}
            onChange={(e) =>
              setMainData((pre) => ({ ...pre, contactNo: e.target.value }))
            }
            sx={{
              gridColumn: "span 2",
              marginTop: "8px",
            }}
          />
          <TextField
            variant="outlined"
            type="text"
            label="Email"
            size="small"
            value={mainData.email}
            onChange={(e) =>
              setMainData((pre) => ({ ...pre, email: e.target.value }))
            }
            sx={{
              gridColumn: "span 2",
              marginTop: "8px",
            }}
          />
          <TextField
            select
            label="Select Technical Officer"
            fullWidth
            size="small"
            helperText={mainData.assignUser?.helperText}
            error={mainData.assignUser?.error}
            value={
              mainData?.assignUser?.id === undefined
                ? ""
                : mainData?.assignUser?.id
            }
            onChange={(e) => {
              setMainData((pre) => ({
                ...pre,
                assignUser: {
                  ...pre.assignUser,
                  id: e.target.value,
                  role: "USER",
                },
              }));
            }}
            sx={{
              marginBottom: "5px",
              marginTop: "8px",
              gridColumn: "span 2",
            }}
          >
            {officers?.map((option) => (
              <MenuItemMui key={option.id} value={option.id}>
                {option.titles.title +
                  " " +
                  option.firstName +
                  " " +
                  option.lastName}
              </MenuItemMui>
            ))}
          </TextField>
          <TextField
            variant="outlined"
            type="text"
            label="Mobile No"
            size="small"
            value={mainData.mobileNo}
            onChange={(e) =>
              setMainData((pre) => ({ ...pre, mobileNo: e.target.value }))
            }
            sx={{
              gridColumn: "span 1",
              marginTop: "8px",
            }}
          />
          <TextField
            variant="outlined"
            type="text"
            label="Whatsapp No"
            size="small"
            value={mainData.whatsAppNo}
            onChange={(e) =>
              setMainData((pre) => ({ ...pre, whatsAppNo: e.target.value }))
            }
            sx={{
              gridColumn: "span 1",
              marginTop: "8px",
            }}
          />
        </Box>
        <Divider sx={{ marginTop: "5px" }} />
        <Box
          sx={{ margin: "10px" }}
          display="flex"
          justifyContent="space-between"
          marginBottom="1px"
        >
          <Button
            type="button"
            startIcon={<Add />}
            color="secondary"
            variant="contained"
            onClick={handleClickOpenModal}
          >
            Add Test
          </Button>
        </Box>
        <Box
          sx={{ marginTop: "10px", width: "100%" }}
          display="flex"
          flexDirection="column"
          marginBottom="1px"
        >
          {labTestsArray.testsArray?.map((data, index) => (
            <AddTestDataToTable
              key={index}
              labTestId={data.labTest.id}
              labTestName={data.labTest.testName}
              reportCollectMethod={data.reportCollectMethod}
              sampleCollectMethod={data.sampleCollectMethod}
              amount={data.labTest.amount}
              quantity={data.quantity}
              startingSerialNo={data.startingSerialNo}
              total={data.total}
              colors={colors}
              isNonMobile={isNonMobile}
              year={mainData.year}
              id={mainData.id}
              autoIdByYear={mainData.autoIdByYear}
              update={update}
              handleRemoveSeleced={handleRemoveSeleced}
              castingDate={data.castingDate}
            />
          ))}
        </Box>
        <Divider>
          <Chip label="TOTAL AMOUNT" size="medium" />
        </Divider>
        <Box
          display="flex"
          sx={{
            marginTop: "8px",
            justifyContent: "space-between",
          }}
        >
          <Box
            gap={1}
            display="grid"
            gridTemplateColumns="repeat(4, minmax(0, 1fr))"
            sx={{
              "& > div": {
                gridColumn: isNonMobile ? undefined : "span 4",
              },
            }}
          >
            <Button
              type="button"
              disabled={loading}
              startIcon={<SaveAlt />}
              color="secondary"
              variant="contained"
              onClick={handleGenerateId}
            >
              {update ? "UPDATE REQUEST" : "SAVE REQUEST"}
            </Button>

            {update ? (
              <Button
                type="button"
                disabled={loading}
                startIcon={<SaveAs />}
                color="secondary"
                variant="contained"
                onClick={handleUpdateTestName}
              >
                UPDATE NAME
              </Button>
            ) : (
              ""
            )}

            <Button
              type="button"
              startIcon={<RestartAlt />}
              color="secondary"
              variant="contained"
              onClick={handleResetForm}
            >
              RESET
            </Button>
          </Box>
          <Box>
            <Typography variant="h2" color="success" fontWeight={550}>
              {labTestsArray.grandTotal.toLocaleString("en-US", {
                style: "currency",
                currency: "LKR",
              })}
            </Typography>
          </Box>
        </Box>
      </Paper>
      {/* <AddDataModal /> */}
      <Paper
        sx={{
          padding: "15px",
          borderRadius: "8px",
          width: "95%",
          marginTop: "15px",
        }}
        elevation={3}
      >
        <Header title="All requests" subtitle="Update / Delete Requests" />
        <Box display="flex" margin={1}>
          <Box display="flex" alignItems="center" gap={1}>
            <Circle sx={{ color: "#FFDB15" }} size="small" />{" "}
            <Typography variant="subtitle1">Unpaid Requests</Typography>
            <TextField
              select
              label="Select year"
              size="small"
              value={currentYear}
              onChange={(e) => {
                setCurrentYear(e.target.value);
                loadBasicData(0, 25, e.target.value);
              }}
              sx={{
                marginBottom: "5px",
                marginTop: "8px",
                gridColumn: "span 2",

                width: "150px",
              }}
            >
              {year?.map((option) => (
                <MenuItemMui key={option.id} value={option.value}>
                  {option.value}
                </MenuItemMui>
              ))}
            </TextField>
          </Box>
        </Box>
        <MaterialReactTable table={table} />
      </Paper>
      <NotificationToaste
        handleCloseToaste={handleCloseToaste}
        open={open}
        message={message}
        messageType={messageType}
      />
      <NewJobAddTest
        openModal={openModal}
        handleCloseModal={handleCloseModal}
        state={state}
        setState={setState}
        isNonMobile={isNonMobile}
        setLabTestsArray={setLabTestsArray}
        labTestsArray={labTestsArray}
        setMessage={setMessage}
        setMessageType={setMessageType}
        setOpen={setOpen}
        assignUser={mainData.assignUser}
      />

      {
        <JobInvoiceDialog
          isNonMobile={isNonMobile}
          handleOpenInvoice={handleClickInvoiceOpenModal}
          handleCloseInvoice={handleInvoiceCloseModal}
          open={openInvoiceModal}
          data={selectedRequestId}
          type="QUOTATION"
        />
      }

      {
        <PDFViewerDialog
          data={selectedRequestId}
          isNonMobile={isNonMobile}
          handleCloseReportPreview={handleProgressCloseModal}
          open={openProgressModal}
          reportType={"PROGRESS"}
        />
      }
    </Box>
  );
});

export default NewJobRequest;
